import { Component, Inject, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ApiService } from "@tylertech/core-module";
import { Command, LabelCommand } from "@tylertech/commands-module";
import { Utilities } from "@tylertech/shared-module";
import { ClassMetadata } from "@tylertech/tyler-api-types";
import { MetadataService } from "../../services/metadata.service";

export interface MetadataDialogData
{
    title: string;
    dataMethod: string;
    metadataMethod: string;
    width: number;
    model: any;
    metadata: ClassMetadata;
    readOnly: boolean;
}

@Component({
    selector: "metadata-dialog-component",
    templateUrl: "./metadata.dialog.tmpl.html",
    standalone: false
})
export class MetadataDialogComponent
{
    readonly commands: ReadonlyArray<Command>;

    loading: boolean = true;
    data: MetadataDialogData;

    @ViewChild("form") form: NgForm;

    constructor(
        private readonly dialogRef: MatDialogRef<MetadataDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private dialogData: MetadataDialogData,
        private readonly $apiService: ApiService,
        private $metadataService: MetadataService
    )
    {
        this.dialogRef.disableClose = true;
        this.data = this.dialogData;

        this.commands = [
            new LabelCommand({
                label: "Done",
                action: () => this.cancel(),
                getEnabled: () => true,
                getVisible: () => this.data.readOnly,
            }),
            new LabelCommand({
                label: "Cancel",
                action: () => this.cancel(),
                getEnabled: () => true,
                getVisible: () => !this.data.readOnly,
            }),
            new LabelCommand({
                label: "OK",
                action: () => this.confirm(),
                getEnabled: () => true,
                getVisible: () => !this.data.readOnly,
            }),
        ];

        if (!this.data.model || !this.data.metadata)
        {
            if (Utilities.IsNullOrUndefinedOrEmpty(this.data.dataMethod))
            {
                console.log("Error: dataMethod not provided!");
                this.cancel();
                return;
            }
            if (Utilities.IsNullOrUndefinedOrEmpty(this.data.metadataMethod))
            {
                console.log("Error: metadataMethod not provided!");
                this.cancel();
                return;
            }
            const self = this;
            this.$apiService.sendAuth(this.data.dataMethod)
                .then(data =>
                {
                    self.data.model = data;
                    self.$apiService.sendAuth(this.data.metadataMethod)
                        .then((metadata: ClassMetadata) =>
                        {
                            self.data.metadata = metadata;
                            self.loading = false;
                        });
                });
        }
        else
        {
            this.loading = false;
        }
    }

    confirm(): void
    {
        if (!this.form.invalid)
        {
            this.dialogRef.close(this.data.model);
        }
        else
        {
            this.$metadataService.touchForm(this.form.controls);
        }
    }

    cancel(): void
    {
        this.dialogRef.close();
    }
}
